import axios from 'axios';

// Detect if running in mobile app or web
// Try to import Capacitor, but don't fail if it's not installed
let isNative = false;
try {
  // @ts-ignore - Capacitor may not be installed during web development
  const Capacitor = require('@capacitor/core').Capacitor;
  if (Capacitor && typeof Capacitor.isNativePlatform === 'function') {
    isNative = Capacitor.isNativePlatform();
  }
} catch (e) {
  // Capacitor not installed, assume web mode
  isNative = false;
}

// Set base URL based on platform
// For mobile app, use your actual server URL (replace with your domain)
// For web/local development, use localhost
const getBaseURL = () => {
  if (isNative) {
    // Replace 'https://yourdomain.com' with your actual server URL
    // Example: 'https://saihome.buzz.com/super2/index.php'
    return 'https://cmmkolkata.com/super/index.php';
  }
  // For web development - check if running on localhost
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Use local backend for development
    return 'https://cmmkolkata.com/super/index.php';
  }
  // For production/staging, use production server
  return 'https://cmmkolkata.com/super/index.php';
};

const axiosInstance =  axios.create({
  baseURL: getBaseURL(),
//   withCredentials: false,
//   crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*',
    // 'app_key': '@34Y@#8deepmatka',
    // 'Access-Control-Allow-Origin' : '*',
    // 'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

axiosInstance.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        console.log('call the refresh token api here')
        // Handle 401 error, e.g., redirect to login or refresh token
      }
      return Promise.reject(error)
    },
  )

  export default axiosInstance;